import Swiper from "swiper/bundle";
import "./_slider-gallery.scss";

document.addEventListener("DOMContentLoaded", () => {
  const SliderGallery = document.querySelectorAll(".slider-gallery");

  SliderGallery.forEach((slider) => {
    const block = slider.closest(".block__slider-gallery");

    new Swiper(slider, {
      loop: false,
      spaceBetween: 20,
      slidesPerView: "auto",
      watchSlidesProgress: true,
      keyboard: { enabled: true },
      speed: 1000,
      // Modulo accessibilità nativo
      a11y: {
        enabled: true,
        prevSlideMessage: "Immagine precedente",
        nextSlideMessage: "Immagine successiva",
        slideLabelMessage: "Slide {{index}} di {{slidesLength}}",
      },
      pagination: {
        el: block.querySelector(".swiper-pagination"),
        type: "fraction",
      },
      navigation: {
        nextEl: block.querySelector(".swiper-button-next-custom"),
        prevEl: block.querySelector(".swiper-button-prev-custom"),
      },
      on: {
        init: function () {
          updateGalleryA11y(this, block);
        },
        slideChangeTransitionEnd: function () {
          updateGalleryA11y(this, block);
          announceGalleryUpdate(this); // Annuncio vocale
        },
        resize: function () {
          updateGalleryA11y(this, block);
        },
      },
    });
  });

  // =========================================================
  // FUNZIONI DI SUPPORTO PER ACCESSIBILITÀ GALLERIA
  // =========================================================

  function updateGalleryA11y(swiper, block) {
    // 1. Gestione visibilità controlli (la tua logica mantenuta)
    const shouldHide = swiper.isLocked || swiper.slides.length <= 1;
    if (block.querySelector(".swiper-controls")) {
      block.querySelector(".swiper-controls").style.display = shouldHide
        ? "none"
        : "";
    }

    // 2. Gestione aria-hidden e tabindex basata sull'effettiva visibilità
    swiper.slides.forEach((slide) => {
      // Usiamo swiper-slide-visible invece di activeIndex per supportare slidesPerView: "auto"
      if (slide.classList.contains("swiper-slide-visible")) {
        slide.setAttribute("aria-hidden", "false");
        slide.setAttribute("tabindex", "0"); // Rende la slide focusabile per leggere l'alt dell'immagine
      } else {
        slide.setAttribute("aria-hidden", "true");
        slide.setAttribute("tabindex", "-1");
      }
    });

    // 3. Gestione tabindex sui bottoni di navigazione
    const checkBtnDisabled = (btn) => {
      if (btn) {
        if (btn.classList.contains("swiper-button-disabled")) {
          btn.setAttribute("tabindex", "-1");
        } else {
          btn.setAttribute("tabindex", "0");
        }
      }
    };
    checkBtnDisabled(swiper.navigation.nextEl);
    checkBtnDisabled(swiper.navigation.prevEl);
  }

  // 4. Live Region per l'annuncio dello spostamento
  function announceGalleryUpdate(swiper) {
    const liveRegionId = "swiper-gallery-live-announcer";
    let liveRegion = document.getElementById(liveRegionId);

    if (!liveRegion) {
      liveRegion = document.createElement("div");
      liveRegion.id = liveRegionId;
      liveRegion.setAttribute("aria-live", "polite");
      liveRegion.style.position = "absolute";
      liveRegion.style.width = "1px";
      liveRegion.style.height = "1px";
      liveRegion.style.overflow = "hidden";
      document.body.appendChild(liveRegion);
    }

    const current = swiper.activeIndex + 1;
    const total = swiper.slides.length;
    liveRegion.textContent = `Galleria immagini: foto ${current} di ${total}`;
  }
});
